import React from 'react';

interface AdminStatsProps {
  totalUsers: number;
  totalMedications: number;
  pendingCount: number;
  totalSubmissions: number;
}

export default function AdminStats({
  totalUsers,
  totalMedications,
  pendingCount,
  totalSubmissions
}: AdminStatsProps) {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
      <div className="bg-pure-white p-6 rounded-md shadow-card">
        <h3 className="text-section-header text-gray-900 font-inter">Form Submissions</h3>
        <p className="text-display text-trust-blue font-inter">{totalSubmissions}</p>
        <p className="text-supporting text-text-secondary">New patient forms</p>
      </div>
      <div className="bg-pure-white p-6 rounded-md shadow-card">
        <h3 className="text-section-header text-gray-900 font-inter">Total Users</h3>
        <p className="text-display text-trust-blue font-inter">{totalUsers}</p>
        <p className="text-supporting text-text-secondary">Registered users</p>
      </div>
      <div className="bg-pure-white p-6 rounded-md shadow-card">
        <h3 className="text-section-header text-gray-900 font-inter">Total Medications</h3>
        <p className="text-display text-wellness-mint font-inter">{totalMedications}</p>
        <p className="text-supporting text-text-secondary">In the system</p>
      </div>
      <div className="bg-pure-white p-6 rounded-md shadow-card">
        <h3 className="text-section-header text-gray-900 font-inter">Pending Verification</h3>
        <p className="text-display text-energy-coral font-inter">{pendingCount}</p>
        <p className="text-supporting text-text-secondary">Awaiting review</p>
      </div>
    </div>
  );
}